import initFavorite from './modules/Favorite';

document.addEventListener('DOMContentLoaded', () => {
  initFavorite();
});
